"use strict";
exports.__esModule = true;
var Summaries = require("./eventProperties/ActiveSessionSummaries");
var DeviceInteractionVector_1 = require("./eventProperties/DeviceInteractionVector");
var ExtendedData_1 = require("./eventProperties/ExtendedData");
var OverrideableProperties_1 = require("./eventProperties/OverrideableProperties");
var PageImpressionContextMap_1 = require("./eventProperties/PageImpressionContextMap");
var ComponentEventProperties = (function () {
    function ComponentEventProperties() {
    }
    ComponentEventProperties.ExtendedData = new ExtendedData_1.ExtendedData();
    ComponentEventProperties.PrivacyTags = new OverrideableProperties_1.PrivacyTagProperties();
    ComponentEventProperties.Keywords = new OverrideableProperties_1.EventKeywordProperties();
    ComponentEventProperties.Persistence = new OverrideableProperties_1.EventPersistenceProperties();
    ComponentEventProperties.Latency = new OverrideableProperties_1.EventLatencyProperties();
    ComponentEventProperties.GroupIdType = new OverrideableProperties_1.GroupIdTypeProperties();
    ComponentEventProperties.ActiveSessionSummaries = Summaries;
    return ComponentEventProperties;
}());
exports.ComponentEventProperties = ComponentEventProperties;
var ClickstreamEventProperties = (function () {
    function ClickstreamEventProperties() {
    }
    ClickstreamEventProperties.DeviceInteractionVector = new DeviceInteractionVector_1.DeviceInteractionVector();
    ClickstreamEventProperties.PageImpressionContext = new PageImpressionContextMap_1.PageImpressionContextMap();
    return ClickstreamEventProperties;
}());
exports.ClickstreamEventProperties = ClickstreamEventProperties;
//# sourceMappingURL=EventProperties.js.map